/**
 * Constants for sensitivity labels and icons
 */ /**
 * Enum representing different types of sensitivity icons
 */ export var SensitivityIconType = /*#__PURE__*/ function(SensitivityIconType) {
    /** Unknown or unrecognized sensitivity tag */ SensitivityIconType["TagUnknown"] = "TagUnknown";
    /** Standard sensitivity tag */ SensitivityIconType["Tag"] = "Tag";
    /** Protected sensitivity tag with lock */ SensitivityIconType["TagProtected"] = "TagProtected";
    /** Required sensitivity tag with error indicator */ SensitivityIconType["TagRequired"] = "TagRequired";
    return SensitivityIconType;
}({});
